import React from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const effectiveDate = new Date().toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });

  return (
    <div className="container-fluid maxContainerSection mainHeaderPadding ">
      <div className="row alignCenterSection">
        <div className="col-md-10">
          <div className="commonPadding pb-0">
            <div className="policyHeaderSection">
              <h1 className="m-0 h1Class">
                {t("SMSHub_angola")} <br />
                {t("privacy_policy")}
              </h1>
              <p className="m-0 peraClass">
                {t("last_updated")} {effectiveDate}
              </p>
            </div>

            <div>
              <div className="policyContentSection">
                <p className="m-0">{t("privacy_policy_desc")}</p>
                <p className="m-0">{t("privacy_policy_desc_sec")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">1. {t("information_collect")}</h3>
                <p className="m-0">{t("information_collect_desc")}</p>

                <h4 className="m-0 h4Class">1.1 {t("corporate_data")}</h4>
                <p className="m-0">{t("corporate_data_desc")}</p>
                <ul>
                  <li>{t("corporate_data_desc_first")}</li>
                  <li>{t("corporate_data_desc_sec")}</li>
                  <li>{t("corporate_data_desc_third")}</li>
                  <li>{t("corporate_data_desc_four")}</li>
                  <li>{t("corporate_data_desc_five")}</li>
                </ul>

                <h4 className="m-0 h4Class">1.2 {t("usage_data")}</h4>
                <p className="m-0">{t("usage_data_desc")}</p>

                <h4 className="m-0 h4Class">
                  1.3 {t("tracking_cookies_data")}
                </h4>
                <p className="m-0">{t("tracking_cookies_data_desc")}</p>

                <p className="m-0">{t("tracking_cookies_data_desc_sec")}</p>
                <p className="m-0">{t("tracking_cookies_data_desc_third")}</p>
                <p className="m-0">{t("examples_cookies")}</p>
                <ul>
                  <li>{t("session_cookies")}</li>
                  <li>{t("preference_cookies")}</li>
                  <li>{t("security_cookies")}</li>
                </ul>
              </div>
              <div className="policyContentSection">
                <h3 className="m-0 h3Class">2 {t("use_data")}</h3>
                <p className="m-0">{t("use_data_desc")}</p>
                <ul>
                  <li>{t("use_data_first")}</li>
                  <li>{t("use_data_sec")}</li>
                  <li>{t("use_data_third")}</li>
                  <li>{t("use_data_four")}</li>
                  <li>{t("use_data_five")}</li>
                  <li>{t("use_data_six")}</li>
                  <li>{t("use_data_seven")}</li>
                  <li>{t("use_data_eight")}</li>
                </ul>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">3 {t("data_transfer")}</h3>
                <p className="m-0">{t("data_transfer_desc")}</p>
                <p className="m-0">{t("data_transfer_desc_sec")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">4 {t("disclosure_data")}</h3>
                <h4 className="m-0 h4Class">4.1. {t("legal_requirements")}</h4>
                <p className="m-0">
                  {t("data_transflegal_requirements_descer_desc")}
                </p>
                <ul>
                  <li> {t("legal_requirements_first")}</li>
                  <li> {t("legal_requirements_sec")}</li>
                  <li>{t("legal_requirements_third")}</li>
                  <li>{t("legal_requirements_four")}</li>
                  <li>{t("legal_requirements_five")}</li>
                </ul>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">5 {t("security_data")}</h3>
                <p className="m-0">{t("security_data_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">6 {t("links_other_sites")}</h3>
                <p className="m-0">{t("links_other_sites_desc")}</p>
                <p>{t("links_other_sites_desc_sec")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">7 {t("children_privacy")}</h3>
                <p className="m-0">
                  {t("children_privacy_desc")}
                </p>
                <p>
                  {t("children_privacy_desc_sec")}
                </p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">
                  8 {t("changes_privacy_policy")}
                </h3>
                <p className="m-0">
                  {t("changes_privacy_policy_desc")}
                </p>
                <p>
                  {t("changes_privacy_policy_desc_sec")}
                </p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">9. {t("contact_us")}</h3>
                <p className="m-0">{t("contact_us_desc_new")}</p>
                <ul>
                  <li> geral@g-corporate.com</li>
                  <li> +244 935 516 476.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
